<template>
<div class="container-fluid">
    <nav class="navbar navbar-light fixed-top bg-dark flex-md-nowrap py-2 shadow topnavbar">
        <button class="btn btn-primary" type="button" @click="showSideNav">
              <i class="fas fa-bars fa-sm"></i>
        </button>
        <router-link class="navbar-brand col-sm-3 col-md-2 mr-0" :to="{name:'user-home'}">
           actionCommons
        </router-link>
          <form class="form-inline ml-auto w-100 navbar-search">
              <div class="input-group">
                <input type="text" class="form-control bg-light border-0 small p-1" placeholder="Search for..." aria-label="Search" aria-describedby="basic-addon2">
                  <div class="input-group-append">
                    <button class="btn btn-primary" type="button">
                      <i class="fas fa-search fa-sm"></i>
                   </button>
                </div>
            </div>
          </form>
        <ul class="navbar-nav px-3">
          <li class="nav-item text-nowrap ">
            <a class="nav-link signout" href="#">Sign out</a>
          </li>
        </ul>
      </nav> 

      <div class="container-fluid">
      <div class="row">
        <nav class="col-md-2  bg-light sidebar">
          <div class="sidebar-sticky">
            <ul class="nav flex-column border-bottom  ">
              <li class="nav-item border-bottom pb-3">
                <a class="nav-link active " href="/user/home">
                  
                  Home<span class="sr-only">(current)</span>
                </a>
              </li>
              <h6 class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted">
              <span>CATEGORIES</span>
              <a class="d-flex align-items-center text-muted" href="#">
                <span data-feather="plus-circle"></span>
                
              </a>
             </h6>
              <li class="nav-item"   v-for="(category, key) in categories" :key="key">
                <router-link class="nav-link" :to="{name:'submit-agreement', params:{id:category.id, name:category.name} }">
                   {{category.name}} 
                </router-link>
              </li>
            </ul>

            <h6 class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-1 mb-1 text-muted">
              <span>Saved</span>
              <a class="d-flex align-items-center text-muted" href="#">
                <span data-feather="plus-circle"></span>
              </a>
            </h6>
            <ul class="nav flex-column mb-2">
              <li class="nav-item">
                <router-link class="nav-link" :to="{name:'user-agreements'}">
                  My agreements
                </router-link>
              </li>
            </ul>
          </div>
        </nav>

        <!-- main content goes here ---->
        <main role="main" class="col-md-9 ml-sm-auto mt-5 col-lg-10 px-4">
          <!-- route page contents here />
            ****
            ***
            *
            -->
            <router-view />
        </main>
        <!--- end of the page main content --->
      </div>
    </div> 
</div>
</template>

<script>
export default {
    data(){
      return {

      }
    },
    methods:{
      showSideNav(){
         const nav = document.querySelector('.sidebar')
         nav.classList.toggle('show')
         nav.classList.remove('col-md-2')
         //nav.classList.remove('sidebar')
         nav.classList.add('col-12')
      }
    },
     computed:{
      categories() {
        return this.$store.state.contributor.categories;
      },
      success(){
        return this.$store.state.contributor.success
      },
      loading() {
        return this.$store.state.contributor.loading
      }
   },
    created() {
      this.$store.dispatch('contributor/getCategories')
      console.log(this.categories)
  }
    
}
</script>

<style scoped>
/* 
*
Top navbar
*/
.topnavbar{
  background-color:#fff !important;

}
.topnavbar .navbar-brand{
  color:#192440;
  font-weight: bold;
}
.signout{
  color:#192440 !important;
}
/*
 * Sidebar
 */

.sidebar {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 100;
  padding: 60px 0 0; 
  box-shadow: inset -1px 0 0 rgba(0, 0, 0, .1);
}

.sidebar-sticky {
  position: relative;
  top: 0;
  height: calc(100vh - 48px);
  padding-top: .5rem;
  overflow-x: hidden;
  overflow-y: auto;
}

@supports ((position: -webkit-sticky) or (position: sticky)) {
  .sidebar-sticky {
    position: -webkit-sticky;
    position: sticky;
  }
}

.sidebar .nav-link {
  font-weight: 500;
  color: #333;
  padding-bottom:0!important;
}

.sidebar .nav-link .feather {
  margin-right: 4px;
  color: #999;
}

.sidebar .nav-link.active {
  color: #007bff;
}

.sidebar .nav-link:hover .feather,
.sidebar .nav-link.active .feather {
  color: inherit;

}
.nav-item .nav-link:hover{
  cursor:pointor !important;
}
.sidebar-heading {
  font-size: .75rem;
  text-transform: uppercase;
}
/** show sidenav */
.show{
  display: block !important;
  position:absolute;
}
/*
 * Content
 */
 

[role="main"] {
  padding-top: 48px;
}
@media screen and (max-width: 767px) {
  .sidebar {
    display:none;
  }
}

</style>